import { createTheme as p, alpha as i } from "@mui/material";
import { red as l } from "@mui/material/colors";
const d = ({ LinkBehavior: o, Colour: e, GenerateCss: a, PaletteOverrides: r }) => p({
  cssVariables: a ? {
    colorSchemeSelector: "data"
  } : !1,
  colorSchemes: {
    dark: {
      palette: {
        primary: {
          main: e ?? "#0377fc"
        },
        ...r == null ? void 0 : r.dark
      }
    },
    light: {
      palette: {
        primary: {
          main: e ?? "#0377fc"
        },
        ...r == null ? void 0 : r.light
      }
    }
  },
  typography: {
    fontFamily: "Inter",
    h1: {
      fontSize: "2rem",
      fontWeight: "500"
    },
    caption: {
      color: a ? "var(--mui-palette-text-secondary)" : void 0
    },
    disabled: {
      color: a ? "var(--mui-palette-text-disabled)" : void 0
    }
  },
  components: {
    MuiLink: {
      defaultProps: {
        component: o
      }
    },
    MuiButtonBase: {
      defaultProps: {
        LinkComponent: o
      }
    },
    MuiListItemButton: {
      defaultProps: {
        LinkComponent: o
      }
    },
    MuiCssBaseline: {
      styleOverrides: () => ({ ":root": {
        "--app-background": "linear-gradient(335deg, rgb(var(--mui-palette-primary-mainChannel) / .3) 0%, rgb(var(--mui-palette-common-backgroundChannel) / .9) 75%, rgb(var(--mui-palette-common-backgroundChannel) / .9) 100%)"
      } })
    },
    MuiPaper: {
      variants: [
        {
          props: { variant: "translucent" },
          // Custom variant
          style: ({ theme: t }) => ({
            backgroundColor: i(t.palette.background.default, 0.85)
          })
        }
      ]
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none"
        },
        contained: ({ theme: t }) => ({
          textTransform: "none",
          backgroundColor: t.palette.primary.main,
          color: t.palette.primary.contrastText
        })
      },
      variants: [
        {
          props: { size: "extraSmall" },
          style: {
            padding: "4px 6px",
            fontSize: ".8rem",
            "& .MuiButton-startIcon, & .MuiButton-endIcon": {
              fontSize: ".8rem",
              "& svg": { fontSize: ".8rem" },
              // Ensures SVG icons resize
              marginLeft: "unset",
              marginRight: "6px"
            }
          }
        }
      ]
    },
    MuiIconButton: {
      defaultProps: {
        LinkComponent: o
      },
      styleOverrides: {
        root: (t) => ({
          ...t.ownerState.variant === "background" && {
            backgroundColor: "var(--mui-palette-grey-800)",
            color: "#fff"
          }
        })
      }
    },
    MuiTypography: {
      variants: [
        {
          props: {
            variant: "h3"
          },
          style: {
            fontSize: "1.1rem",
            fontWeight: "400"
          }
        }
      ]
    },
    MuiBadge: {
      styleOverrides: {
        badge: {
          backgroundColor: l[800],
          color: "#fff"
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: "3px",
          fontWeight: "300",
          height: "auto"
        },
        sizeSmall: {
          fontSize: ".7rem",
          padding: "2px 2px"
        },
        iconSmall: {
          minWidth: "14px",
          height: "14px"
        },
        avatarSmall: {
          marginLeft: "0px",
          marginRight: "unset",
          fontWeight: "500",
          width: "auto",
          "& > img": {
            padding: "0px",
            width: "18px"
          },
          "&:not(:has(img))": {
            minWidth: "14px",
            padding: "0px 5px"
          }
        },
        label: {
          textWrap: "wrap"
        }
      }
    },
    MuiTab: {
      defaultProps: {
        LinkComponent: o
      },
      styleOverrides: {
        root: {
          textTransform: "unset"
        }
      }
    },
    MuiTableHead: {
      styleOverrides: {
        root: ({ theme: t }) => ({
          backgroundColor: t.palette.mode === "dark" ? "rgb(20, 20, 20)" : "rgb(240, 240, 240)"
        })
      }
    },
    MuiAlert: {
      styleOverrides: {
        root: ({ ownerState: t, theme: n }) => t.severity === "theme" ? {
          backgroundColor: i(n.palette.primary.main, 0.1),
          "& .MuiAlert-icon": {
            color: n.palette.primary.main
          },
          "& .MuiAlert-message": {
            color: "var(--mui-palette-text-primary)"
          }
        } : {}
      }
    }
  }
});
export {
  d as daymapTheme
};
//# sourceMappingURL=index.js.map
